export enum PlayerPosition {
  ATTACK = 'Attack',
  MIDDIE = 'Middie',
  DEFENSE = 'Defense',
  LSM = 'LSM',
  FOGO_DRAW = 'Fogo/Draw',
  GOALIE = 'Goalie',
  OTHER = 'Other',
}
